import { PropTypes } from 'prop-types';
import React from 'react';

import QuickbooksLogo from '../../../assets/svg/quickbooks-mc/quickbooks-logo.svg';
import QuickbooksMailchimpLogo from '../../../assets/svg/quickbooks-mc/quickbooks-mailchimp-logo.svg';

const CallToAction = ({ content, qbMcLogo = false }) => {
  return (
    <section className="partnerships-quickbooks-mailchimp__cta partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__center partnerships-quickbooks-mailchimp__bg--beige">
      <div className="partnerships-global-container">
        <div className="partnerships-global-small">
          {qbMcLogo ? (
            <div className="partnerships-quickbooks-mailchimp__qbmc-logo">
              <QuickbooksMailchimpLogo />
            </div>
          ) : (
            <div className="partnerships-quickbooks-mailchimp__qb-logo">
              <QuickbooksLogo />
            </div>
          )}
          <div className="partnerships-quickbooks-mailchimp__cta-content">
            {content}
          </div>
        </div>
      </div>
    </section>
  );
};

CallToAction.propTypes = {
  content: PropTypes.string,
  qbMcLogo: PropTypes.bool,
};

export default CallToAction;
